"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _HyphenDepositWorkflowComponent = _interopRequireDefault(require("./HyphenDepositWorkflowComponent"));
var _depositWithdrawalSelectors = require("../../../../../redux/selectors/depositWithdrawalSelectors");
var _config = _interopRequireDefault(require("../../../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var product = (0, _depositWithdrawalSelectors.depositProductSelector)(state);
  return {
    product: product,
    bankInfo: _config["default"].Deposit[product.Product]
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_HyphenDepositWorkflowComponent["default"]);